<script lang="ts">
  export default {
    name: 'ExportButton',
  };
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { Download } from 'lucide-vue-next';
import { computed,  inject, } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');

// ----------
// computed
// ----------
const exportListShowing = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.showExportOptions;
});

// ----------
// handlers
// ----------
function  toggleExportOptions(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(StoreMutationType.SHOW_TOWER_EXPORT_OPTIONS, !store?.state.towerCanvasState.showExportOptions);
}
</script>

<template>
  <div class="tw:py-2 tw:self-end">
    <label title="Export">
      <input
        type="checkbox"
        name="export-button"
        aria-label="Export Button"
        class="tw:box-border tw:pointer-events-none tw:hidden"
        @click="toggleExportOptions"
      />
      <div :class="{ selected: exportListShowing }"
              class="button toggle-button tw:flex tw:items-center tw:justify-center tw:cursor-pointer tw:pointer-events-auto
              tw:border-box tw:rounded-lg tw:shadow-lg tw:w-10 tw:h-10">
          <Download :size="18" />
      </div>
    </label>
  </div>
</template>
  
<style scoped>
.toggle-button {
  background-color: var(--tower-v2-alt-bg-color);
  border: 1px solid var(--tower-v2-border-color);
}

.selected {
  background-color: var(--tower-v2-tool-selected-color);
}

.button:hover {
  background-color: var(--tower-v2-hover-color);
}
</style>
  
